/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "../assets/scss/core/sections/_projects.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import projects from "../data/projects.json";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";

function Projects() {
  const { t, i18n } = useTranslation();

  const [fetch, setFetch] = useState([]);

  useEffect(() => {
    // Choose language
    if (i18n.language === "en") {
      setFetch(projects.projectsEN);
    } else {
      setFetch(projects.projectsDE);
    }

    // Initialize AOS once
    AOS.init({ once: true });
  }, [i18n.language]);

  // Determine status label
  const getStatusLabel = (year) => {
    if (!year) return t("Renovated");

    if (["2022", "2023", "2024", "2025"].includes(year)) return t("NewlyBuilt");
    if (year === "1966") return t("Renovated");

    return null;
  };

  return (
    <section id="projects" className="projects">
      <div className="container pt-5 pb-5 text-center">
        <h2 className="section-title">{t("References")}</h2>
        <div className="row">
          {fetch.map(({ id, link, img, timer, name, desc2, images }) => {
            const statusText = getStatusLabel(desc2);

            // Main image from public folder
            const imageUrl =
              process.env.PUBLIC_URL + (img.startsWith("/") ? img : "/" + img);

            // Prepare gallery images
            const galleryImages = images?.map((i) => ({
              original:
                process.env.PUBLIC_URL +
                (i.original.startsWith("/") ? i.original : "/" + i.original),
              thumbnail:
                process.env.PUBLIC_URL +
                (i.thumbnail.startsWith("/") ? i.thumbnail : "/" + i.thumbnail),
            }));

            return (
              <div
                className="col-md-4 col-sm-8"
                data-aos="fade-up"
                data-aos-duration={timer}
                key={id}
              >
                <Link to={`/${link}`} className="link">
                  <div className="box-image">
                    <button className="slider-arrow prev-arrow" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M20.75 25.5L13.25 18L20.75 10.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <circle cx="18" cy="18" r="17.5" stroke="white"/>
                        </svg>
                      </button>

                      {/* Right Arrow (Your Original SVG) */}
                      <button className="slider-arrow next-arrow" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15.25 25.5L22.75 18L15.25 10.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <circle cx="18" cy="18" r="17.5" transform="matrix(-1 0 0 1 36 0)" stroke="white"/>
                        </svg>
                      </button>
                    {/* Image Layer */}
                    <div
                      className="image transition"
                      style={{
                        backgroundImage: `url(${imageUrl})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    ></div>

                    {/* Shadow Layer */}
                    <div className="shadow transition"></div>

                    {/* Status Label */}
                    {statusText && (
                      <div className="status-label">{statusText}</div>
                    )}

                    {/* Text Layer */}
                    <div className="desc center">
                      <h4>{name || link}</h4>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Projects;